import { isPriceTestingEnabledCookieSet } from "@/react/utils/isCookieSet";

import { useExperimentEnabled } from "./useExperimentEnabled";

const PROFESSIONAL_PRICE_TESTING_FLAG_NAME =
  "professional_yearly_price_2026_test";

export const usePriceTestingEnabled = () => {
  const isProfessionalPriceTestEnabled = useExperimentEnabled(
    PROFESSIONAL_PRICE_TESTING_FLAG_NAME,
  );

  return isProfessionalPriceTestEnabled || isPriceTestingEnabledCookieSet();
};
